
export interface AppState {
    loader: boolean;
    language: string;
    brand: string;
}

export default {
    namespaced: true as true,
    state: {
        loader: false,
        language: "en",
        brand: "Purmo"
    } as AppState,
    getters: {
        getLoader: (state: AppState) => state.loader,
        getLanguage: (state: AppState) => state.language,
        getBrand: (state: AppState) => state.brand,
    },
    mutations: {
        SET_LOADER(state: AppState, newState: boolean) {
            state.loader = newState;
        },
        SET_LANGUAGE(state: AppState, language: string) {
            state.language = language;
        },
        SET_BRAND(state: AppState, brand: string) {
            console.log('set brand');
            state.brand = brand;
        },
    },
    actions: {
        setLoaderOn({ commit }: any) {
            commit('SET_LOADER', true)
        },
        setLoaderOff({ commit }: any) {
            commit('SET_LOADER', false)
        },
        setLanguage({ commit }: any, payload: { language: string }){
            commit('SET_LANGUAGE', payload.language)
        },
        setBrand({ commit }: any, payload: { brand: string }){
            commit('SET_LANGUAGE', payload.brand)
        }
    }
}